module.exports = __webpack_public_path__ + "static/madcomputer-81581240ac3f7537fe1ed1b29ed353c0.gif";